<template>
  <div v-if="branches.length" class="branch-switcher branch-switcher--header">
    <button
      class="branch-switcher__button"
      type="button"
      :aria-expanded="open ? 'true' : 'false'"
      @click="open = !open"
    >
      <i class="fas fa-clinic-medical"></i>
      <span><small>Cabang aktif</small><strong>{{ selectedLabel }}</strong></span>
      <i class="fas fa-chevron-down caret"></i>
    </button>
    <div v-if="open" class="branch-switcher__menu">
      <header><span>Pilih ruang kerja</span><small>Data operasional mengikuti cabang aktif</small></header>
      <button
        v-for="branch in branches"
        :key="branch.id"
        type="button"
        :class="{ active: String(selected) === String(branch.id) }"
        @click="choose(branch.id)"
      >
        <i class="fas fa-map-marker-alt"></i>
        <span><strong>{{ branch.name }}</strong><small>{{ branch.code }}<template v-if="branch.is_default"> · Default</template><template v-if="verticalSummary(branch)"> · {{ verticalSummary(branch) }}</template></small></span>
        <i v-if="String(selected) === String(branch.id)" class="fas fa-check"></i>
      </button>
      <button v-if="canConsolidate" type="button" :class="{ active: selected === 'all' }" @click="choose('all')">
        <i class="fas fa-layer-group"></i>
        <span><strong>Seluruh cabang</strong><small>Dashboard &amp; laporan konsolidasi</small></span>
        <i v-if="selected === 'all'" class="fas fa-check"></i>
      </button>
      <router-link v-if="canManage" to="/branch-network" @click.native="open = false"><i class="fas fa-cog"></i> Kelola jaringan klinik</router-link>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import BranchNavigationService from "@/core/services/branch-navigation.service.js";
import VerticalSkinService from "@/core/services/vertical-skin.service.js";

export default {
  name: "BranchSwitcher",
  data: () => ({ branches: [], selected: localStorage.getItem("medhop_branch_id") || null, canConsolidate: false, open: false }),
  computed: {
    selectedLabel() {
      if (this.selected === "all") return "Seluruh cabang";
      const item = this.branches.find(branch => String(branch.id) === String(this.selected));
      return item ? item.name : "Memuat...";
    },
    canManage() {
      const raw = localStorage.getItem("access_right_display") || localStorage.getItem("access_right") || "";
      return raw.includes("10802") || raw.includes("10801");
    },
  },
  mounted() {
    this.load();
    this.$root.$on("branchesUpdated", this.load);
    document.addEventListener("click", this.outside);
  },
  beforeDestroy() {
    this.$root.$off("branchesUpdated", this.load);
    document.removeEventListener("click", this.outside);
  },
  methods: {
    async load() {
      try {
        const response = await ApiService.get("branch-context");
        const data = response.data.data || {};
        this.branches = data.branches || [];
        this.canConsolidate = !!data.can_view_consolidated;
        if (!this.selected) {
          this.selected = data.consolidated ? "all" : data.selected_branch_id;
          if (this.selected) localStorage.setItem("medhop_branch_id", this.selected);
        }
        this.cacheSelectedVerticals(this.selected);
        ApiService.setBranchHeader(this.selected);
      } catch (_) {}
    },
    async choose(id) {
      if (String(id) === String(this.selected)) {
        this.open = false;
        return;
      }
      this.selected = id;
      this.open = false;
      const branch = this.branches.find(item => String(item.id) === String(id));
      await BranchNavigationService.activate(
        id,
        (branch && branch.vertical_codes) || [],
        this.$router,
        this.verticalSkin(branch)
      );
    },
    cacheSelectedVerticals(id) {
      if (id === "all") {
        localStorage.removeItem("medhop_branch_vertical_codes");
        localStorage.removeItem("medhop_branch_vertical_skin");
        VerticalSkinService.apply();
        return;
      }
      const branch = this.branches.find(item => String(item.id) === String(id));
      localStorage.setItem(
        "medhop_branch_vertical_codes",
        JSON.stringify((branch && branch.vertical_codes) || [])
      );
      const skin = this.verticalSkin(branch);
      if (skin) localStorage.setItem("medhop_branch_vertical_skin", skin);
      else localStorage.removeItem("medhop_branch_vertical_skin");
      VerticalSkinService.apply();
    },
    verticalSkin(branch) {
      if (!branch) return "general";
      if (branch.vertical_skin) return branch.vertical_skin;
      const codes = branch.vertical_codes || [];
      if (branch.vertical_configuration_mode === "inherit" || (branch.is_head_office && codes.length > 1)) return "general";
      return codes[0] || "general";
    },
    verticalSummary(branch) {
      const labels = {
        general: "Klinik Umum",
        dental: "Klinik Gigi",
        aesthetic: "Klinik Kecantikan",
        "maternal-child": "Ibu & Anak",
        mcu: "Medical Check Up",
        eye: "Klinik Mata",
        physiotherapy: "Klinik Terapi",
        occupational: "Kesehatan Kerja",
        vaccination: "Vaksinasi",
      };
      const names = (branch.vertical_codes || []).map(code => labels[code] || code);
      return names.length > 2 ? `${names.slice(0, 2).join(", ")} +${names.length - 2}` : names.join(", ");
    },
    outside(event) {
      if (this.$el && !this.$el.contains(event.target)) this.open = false;
    },
  },
};
</script>

<style scoped>
.branch-switcher { position: relative; width: 100%; }
.branch-switcher__button { align-items: center; background: transparent; border: 0; border-radius: 10px; box-shadow: none; color: #fff; display: flex; gap: 10px; height: 52px; padding: 5px 7px; text-align: left; transition: background-color .15s ease, box-shadow .15s ease; width: 100%; }
.branch-switcher__button:hover { background: rgba(255,255,255,.09); }
.branch-switcher__button:focus-visible { background: rgba(255,255,255,.11); box-shadow: 0 0 0 3px rgba(var(--skin-secondary-rgb),.28); outline: none; }
.branch-switcher__button > i:first-child { align-items: center; background: rgba(255,255,255,.13); border: 1px solid rgba(255,255,255,.16); border-radius: 10px; color: #dffff9 !important; display: flex; flex: 0 0 38px; font-size: 17px; height: 38px; justify-content: center; width: 38px; }
.branch-switcher__button > span { display: flex; flex: 1; flex-direction: column; justify-content: center; min-width: 0; }
.branch-switcher__button small { color: rgba(237,251,255,.7); font-size: 9px; font-weight: 750; letter-spacing: .09em; line-height: 1.2; text-transform: uppercase; }
.branch-switcher__button strong { color: #fff; font-size: 14px; font-weight: 750; line-height: 1.35; overflow: hidden; text-overflow: ellipsis; text-shadow: 0 1px 2px rgba(5,38,67,.16); white-space: nowrap; }
.branch-switcher__button .caret { color: rgba(255,255,255,.82) !important; font-size: 9px; transition: transform .15s ease; }
.branch-switcher__button[aria-expanded="true"] .caret { transform: rotate(180deg); }
.branch-switcher__menu { position: absolute; z-index: 1050; top: calc(100% + 7px); left: 0; min-width: 300px; background: #fff; border: 1px solid var(--skin-line); border-radius: 12px; box-shadow: 0 14px 32px rgba(var(--skin-deep-rgb),.24); color: #244657; padding: 7px; width: 100%; }
.branch-switcher__menu header { border-bottom: 1px solid #edf2f4; display: flex; flex-direction: column; padding: 8px 9px; }
.branch-switcher__menu header span { font-weight: 800; }
.branch-switcher__menu header small { color: #78909c; }
.branch-switcher__menu button { align-items: center; background: #fff; border: 0; border-radius: 9px; color: #345565; display: flex; gap: 9px; padding: 9px; text-align: left; width: 100%; }
.branch-switcher__menu button > span { display: flex; flex: 1; flex-direction: column; min-width: 0; }
.branch-switcher__menu button small { color: #8298a3; }
.branch-switcher__menu button.active { background: var(--skin-soft); color: var(--skin-primary); }
.branch-switcher__menu a { border-top: 1px solid #edf2f4; color: var(--skin-primary); display: block; font-weight: 700; margin-top: 6px; padding: 10px; }
@media (max-width: 1180px) {
  .branch-switcher__button { gap: 8px; padding-inline: 4px; }
  .branch-switcher__button > i:first-child { flex-basis: 34px; height: 34px; width: 34px; }
  .branch-switcher__button strong { font-size: 12px; }
  .branch-switcher__menu { min-width: 280px; }
}
</style>
